<script>
import customAcrossRoll from "@/components/custom-across-roll.vue";

export default {
  name: "customTabTime",
  components: {
    customAcrossRoll
  },

  props: {
    timeList: {
      default: () => ([])
    },
    // 是否展示复制按钮
    showCopy: {
      default: () => false
    },
    timeText: {
      default() {
        return '复制排班';
      },
    },
    // 最大复制数量
    showTimeNum: {
      default() {
        return 30;
      },
    },
    // 展示删除按钮
    prohibitDelete: {
      default() {
        return false;
      },
    },
    dateActiveIndex: {
      default() {
        return 0;
      },
    },
    // 展示左右箭头
    showArrow: {
      default() {
        return true;
      },
    }
  },
  data() {
    return {
      mouseIndex: ''
    }

  },
  methods: {
    dateClick(row, index) {
      this.$emit('dateClick', row, index);
    },
    dateHover(type, index) {
      this.mouseIndex = type === 'over' ? index : ''
    },
    removeTime(row, index) {
      this.$emit('removeTime', row, index);
    },
    copyTimeFn(row, index) {
      this.$emit('removeTime', row, index);
    }
  }
}
</script>

<template>
  <div class="customTabTime" style="width: 100%">
    <customAcrossRoll :showArrow="showArrow">
      <div class="date" :class="dateActiveIndex == i ? 'active' : ''" v-for="(item, i) in timeList"
           :key="i" @click="dateClick(item, i)" @mouseover="dateHover('over', i)"
           @mouseout="dateHover('out', i)">
              <span class="date-text">{{ item | week }}
                {{ item | filterTime("MM-DD") }}</span>
        <span v-if="!prohibitDelete" class="date-close" :class="mouseIndex === i ? 'remove' : ''"
              @click.stop="removeTime(item, i)">×</span>
      </div>

      <div class="date" v-show="showCopy" v-if="timeList.length < showTimeNum" @click="copyTimeFn">复制排班</div>
    </customAcrossRoll>
  </div>
</template>

<style scoped lang="less">

.customTabTime {
  #custom-across-roll ::-webkit-scrollbar {
    width: 0px !important;
    height: 0px !important;
  }

  /deep/ .date-group {
    padding-bottom: 0 !important;
  }
}

</style>